import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedInventoryOnParticularDate: [],
};

const inventoryParticularDateSlice = createSlice({
	name: 'inventoryParticularDate',
	initialState: initialState,
	reducers: {
		setInventoryParticularDate: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setInventoryParticularDate, reset } = inventoryParticularDateSlice.actions;

export default inventoryParticularDateSlice.reducer;